import React, { lazy, useState, useEffect, Suspense, useCallback } from 'react';
import { Link } from "react-router-dom";
import Slider from "react-slick";
import { GetTraining } from '../Services/SelfLearning';
import moment from 'moment';
const NewTraining = React.lazy(() => import('./NewTraining'));
const ComponentLoader = React.memo(lazy(() => import('../../../../Shared/Sidebar/ComponentLoader')));
const TrainingChart = React.memo(lazy(() => import('./TrainingsChart')));
const defaultImage = '/images/placeholder_profile.png';

export default function InstructorTrainingDashboard() {
    const [IsLoading, setIsLoading] = useState(false);
    const [trainingList, setTrainingList] = useState([]);
    const [traningArr, setTraningArr] = useState([]);
    let userDetails = JSON.parse(localStorage.getItem("User") || "{}");  
    
    useEffect(() => {
        getTraining(0);
    }, [])

    const handleImageError = useCallback((event) => {
        event.target.src = defaultImage;
    }, []);
    
    async function getTraining(date) {
        setIsLoading(true);
        let params = {
            "OrgId": 0,
            "TrainingId": 0,
            "UserId": userDetails.EmpId,            
        }
        try {
            let responce = await GetTraining(params);          
            let MyTraning = responce?.Data?.trainingsList?.filter((el) => (el?.isUserEnrolled == 1));
            let NewTraning = responce?.Data?.trainingsList?.filter((el) => (el?.isUserEnrolled == 0));
            setTraningArr(NewTraning)
            if (date != 0) {
                let DateFilter = MyTraning?.filter((el) => (el?.startDate?.slice(0, 10) == date));
                setTrainingList(DateFilter);
            } else {
                setTrainingList(MyTraning);
            }
            setIsLoading(false);
        } catch (error) {
            console.error('Error fetching training:', error);
            setIsLoading(false);
        }
    }

    function DateFilter(date) {
        const FilteredDate = new Date(date.year, new Date(`${date.month} 1`).getMonth(), date.day + 1)?.toISOString()?.slice(0, 10);
        getTraining(FilteredDate)
    }

    const [dates, setDates] = useState([]);

    useEffect(() => {
        // generateDates();
        const generatedDates = generateDates();
        setDates(generatedDates);
    }, []);

    function generateDates() {
        const dates = [];
        let min = new Date(2024, 1, 1).valueOf();
        let max = new Date(2024, 11, 24).valueOf();
        let currentDate = new Date(min);
        while (currentDate.valueOf() <= max) {
            dates.push({
                dayName: currentDate.toLocaleString('en-US', { weekday: 'short' }),
                day: currentDate.getDate(),
                month: currentDate.toLocaleString('en-US', { month: 'short' }),
                year: currentDate.getFullYear(),
            });
            currentDate.setDate(currentDate.getDate() + 1);
        }
        // setDates(dates);
        return dates;
    }

    const settings = {
        dots: false,
        infinite: true,
        speed: 200,
        slidesToShow: 1,
        slidesToScroll: 1,
        // width: 400,
        swipeToSlide: true,
    };


    return (

        <div className="position-relation">
            <div id="circular-menu" className="circular-menu">
                <a className="floating-btn">
                    <i aria-hidden="true" className="fa fa-cog fa-spin"></i>
                    <i aria-hidden="true" className="fa fa-times"></i>
                </a>
                <div className="items-wrapper">
                    <div className="menu-item is-flex">
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="feather feather-bell"><path d="M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9"></path><path d="M13.73 21a2 2 0 0 1-3.46 0"></path></svg>
                    </div>
                    <a className="menu-item is-flex right-panel-trigger" data-panel="languages-panel">
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="feather feather-bell"><path d="M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9"></path><path d="M13.73 21a2 2 0 0 1-3.46 0"></path></svg>
                    </a>
                    <Link to="" className="menu-item is-flex">
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="feather feather-bell"><path d="M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9"></path><path d="M13.73 21a2 2 0 0 1-3.46 0"></path></svg>
                    </Link>
                    <a className="menu-item is-flex right-panel-trigger" data-panel="activity-panel">
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="feather feather-grid"><rect x="3" y="3" width="7" height="7"></rect><rect x="14" y="3" width="7" height="7"></rect><rect x="14" y="14" width="7" height="7"></rect><rect x="3" y="14" width="7" height="7"></rect></svg>
                    </a>
                </div>

            </div>
            {/* <!-- row --> */}
            <div className="container-fluid">

                <div className="row trainingmain-div">
                    <div className="col-xl-7">
                        <div className="form-head d-flex flex-wrap align-items-center mb-3">
                            <div className="me-auto">
                                <h2 className="font-w600 mb-0">Trainings</h2>
                                <p className="text-light">Lorem ipsum dolor sit amet</p>
                            </div>
                            <div className="rightside-tabs">
                                <Link to="/InstructorTrainingDashboard/AddNewTraining"><button className="invite-members w-auto float-right"><svg xmlns="http://www.w3.org/2000/svg"
                                    width="18" height="18" fill="currentColor" className="bi bi-plus" viewBox="0 0 16 16"><path d="M8 4a.5.5 0 0 1 .5.5v3h3a.5.5 0 0 1 0 1h-3v3a.5.5 0 0 1-1 0v-3h-3a.5.5 0 0 1 0-1h3v-3A.5.5 0 0 1 8 4"></path></svg>
                                    New Trainings</button></Link>
                            </div>
                        </div>
                        <Suspense >
                            <TrainingChart TrainingList={traningArr} />
                        </Suspense>
                        <strong className='upcome bg-none'>My Trainings</strong>
                        <div className="col-xl-12">
                            <div className="availabilty">
                                <div className="card-body ">
                                    <div className="slider-container">
                                        <Slider {...settings}>
                                            {dates.map((date, index) => (
                                                <div onClick={() => DateFilter(date)} key={index} className={`inner-tumbnail ${date.dayName === 'Sun' ? 'active' : 'off'}`} >
                                                    <h3>{date.dayName}</h3>
                                                    <h4>{date.day}</h4>
                                                    <p>{date.month} {date.year}</p>
                                                </div>
                                            ))}
                                        </Slider>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-xl-12">
                            <div className="row">
                                {trainingList?.length !=0 ? trainingList?.map((lst,index) => (<div className="col-md-4">
                                    <div key={index} className="">
                                        <div className="">
                                            <div>
                                                <Link to={`/InstructorTrainingDashboard/TrainingDetail/${lst?.id}`}>
                                                    <div className="trainings">
                                                        <img className="iconimg" src={lst?.trainingBanner || defaultImage} onError={handleImageError} width="32" style={{ 'opacity': '1' }} />
                                                        <div className="tags d-none"><span>#Website</span><span>#Branding</span><span>#Logo</span></div>
                                                        <div className="card-text">{lst?.title}</div>
                                                        <div className="students pb-0">
                                                            <div className="h-avatar is-small">
                                                                <img className="avatar" src={lst?.profileImage || defaultImage} onError={handleImageError} width="32" style={{ 'opacity': '1' }} />
                                                            </div>
                                                            <a className="link is-dark-primary">{lst?.hostName}</a>
                                                        </div>
                                                        <div className="comment-attach">
                                                            <span className="leveltag text-grey">{moment(lst?.startDate).format('MMM DD YYYY')}</span> to  <span className="leveltag text-grey">{moment(lst?.endDate).format('MMM DD YYYY')}</span><br></br>
                                                            <span><i className="fa fa-clock-o" aria-hidden="true"></i>{lst?.startTime?.slice(0, 5)} - {lst?.endTime?.slice(0, 5)}</span>
                                                        </div>
                                                    </div></Link>
                                            </div>
                                        </div>
                                    </div>
                                </div>))  : <p>No Data Found.</p> }
                            </div>
                        </div>
                    </div>
                    <div className="col-xl-3">
                        <div className="row">
                            <div className="col-xl-12">
                                <div className="premium-plan">
                                    <div className="center">
                                        <a className="add-more" href="/">
                                            <svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" fill="currentColor" className="bi bi-arrow-right-short" viewBox="0 0 16 16">
                                                <path fillRule="evenodd" d="M4 8a.5.5 0 0 1 .5-.5h5.793L8.146 5.354a.5.5 0 1 1 .708-.708l3 3a.5.5 0 0 1 0 .708l-3 3a.5.5 0 0 1-.708-.708L10.293 8.5H4.5A.5.5 0 0 1 4 8" />
                                            </svg></a>
                                        <h3 className="block-heading learnheading">Go Premium</h3>
                                        <p className="block-text">Explore 25k+ courses with lifetime membership
                                        </p>
                                        <button>Get Access</button>
                                    </div>
                                    <img src="images/org-img/training/1.png" />
                                    {/* <!--Right--> */}
                                </div>
                            </div>

                            <div className="col-xl-12">
                                <Suspense >
                                    <NewTraining MyTrainingLists={traningArr} />
                                </Suspense>
                            </div>

                        </div>
                    </div>
                </div>

            </div>
            <div className="modal fade" id="contact-manager">
                <div className="modal-dialog modal-dialog-centered" role="document">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title m-auto">Contact Your Reporting Manager htmlFor Any Leave Clarifications</h5>

                        </div>
                        <div className="modal-body text-center">
                            <form>
                                <div className="form-group text-left">
                                    <label>Repoting Manager</label>
                                    <select className="default-select form-control wide mb-3">
                                        <option selected disabled>Select reporting manager</option>
                                        <option>Arun Mishra</option>
                                        <option>Pragya Tiwari</option>
                                        <option>Alisha Goyal</option>
                                    </select></div>
                                <div className="form-group text-left">
                                    <label className="mt-3">Reason</label>
                                    <textarea rows="4" cols="1" className="form-control"></textarea></div>

                            </form>


                        </div>
                        <div className="modal-footer">
                            <button type="button" className="btn btn-danger light" data-bs-dismiss="modal">Decline</button>
                            <button type="button" className="btn btn-primary">Accept</button>
                        </div>
                    </div>
                </div>
            </div>
            {IsLoading ? <Suspense >
                <ComponentLoader />
            </Suspense> :''}
        </div>
    )

}
